import * as types from "./mutation-type";
import { getBudgetsQuery,getStoreBudgetsQuery } from "./queries.graphql";
import gqlClient from "@/modules/graphql";
import api from "@/modules/api";

const actions = {

  //fetch budgets from company budget
  async getBudgets({ commit }, variables = {}) {
    try {
      commit(types.GET_BUDGETS_BEGIN);
      const {
        data: {
          data         
        }
      } = await gqlClient.query({
        query     : variables.isStore ? getStoreBudgetsQuery : getBudgetsQuery,
        variables : variables
      });
      commit(types.GET_BUDGETS_SUCCESS, variables.isStore ? data.store.budgets : data.company.budgets);
    } catch (e) {
      commit(types.GET_BUDGETS_ERROR, e);
    }
  },

  //delete budget
  async deleteBudget({ commit }, id) {
    try {
      commit(types.DELETE_BUDGET_BEGIN);
      await api.budget.deleteBudget(id);
      commit(types.DELETE_BUDGET_SUCCESS, id);
    } catch (e) {
      commit(types.DELETE_BUDGET_ERROR, e);
    }
  },

  //create new budget
  async createBudget({ commit }, variables ) { 
    try {
      commit(types.CREATE_BUDGET_BEGIN)
      const { data } = await api.budget.addBudget(variables)
      commit(types.CREATE_BUDGET_SUCCESS, data)
    } catch (e) {
      commit(types.CREATE_BUDGET_ERROR, e)
    }
  },

  //update budget by its id
  async updateBudget({ commit }, { id, data }){
    commit(types.UPDATE_BUDGET_BEGIN)
    try {
      const { data : updatedData } = await api.budget.update(id,data)
      commit(types.UPDATE_BUDGET_SUCCESS, updatedData)
    } catch (error) {
      commit(types.UPDATE_BUDGET_ERROR, error)
    }
  },

  //create budget in user_emp section
  async createStoreBudget({ commit, rootState }, userData) { 
    try {
      commit(types.ADD_STORE_BUDGET_BEGIN,userData.storeId)
      const { data } = await api.storeBudget.addStoreBudget(userData)
      commit(types.ADD_STORE_BUDGET_SUCCESS, { data, rootState })
    } catch (err) {
      commit(types.ADD_STORE_BUDGET_ERROR, { err, storeId : userData.storeId })
    }
  },

  //delete budget in user_emp section
  async deleteStoreBudget({ commit, rootState }, { id, storeId }) {
    try {
      commit(types.DELETE_STORE_BUDGET_BEGIN, storeId);
      await api.storeBudget.deleteStoreBud(id);
      commit(types.DELETE_STORE_BUDGET_SUCCESS, { storeId, rootState });
    } catch (err) {
      commit(types.DELETE_STORE_BUDGET_ERROR, { err, storeId });
    }
  }
};

export default actions;